let accordions = document.querySelectorAll('.accordion');
let accordions_nested = document.querySelectorAll('.accordion');
let acc = document.getElementsByClassName("accordion");
let i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function () {
    this.classList.toggle("active");
    let panel = this.nextElementSibling;

    panel.classList.toggle('active');
  });
}